// 此模块仅由产品详情页加载，目标由 main-product 明确标记。
const placements = new Map();
const carouselSelector = 'media-card-carousel[data-product-information-placement]';
const targetSelector = '[data-product-information-carousel-target]';

function moveContent(carousel, content, parent, before = null) {
  // append/insert 会触发自定义元素的断开与连接回调，移动期间保留现有实例。
  carousel.isMovingToProductInformation = true;
  try {
    parent.insertBefore(content, before);
  } finally {
    carousel.isMovingToProductInformation = false;
  }
  const swiper = carousel.swiper;
  if (swiper) {
    // 同步 Swiper 的间距和断点配置，确保卡片宽度与滑动距离一起更新。
    const isProductInformation = Boolean(carousel.closest('.product-information--inner'));
    const centered = carousel.dataset.layout === 'centered';
    const mobileSpacing = centered ? 0 : isProductInformation ? 8 : 15;
    const desktopSpacing = centered ? 0 : isProductInformation ? 8 : 20;
    swiper.originalParams.spaceBetween = mobileSpacing;
    swiper.originalParams.breakpoints[750].spaceBetween = desktopSpacing;
    swiper.params.breakpoints[750].spaceBetween = desktopSpacing;
    swiper.params.spaceBetween = window.innerWidth >= 750 ? desktopSpacing : mobileSpacing;
    swiper.update();
  }
}

function restorePlacement(carousel, placement) {
  const { content, anchor } = placement;
  content.classList.remove('section-media-card-carousel--product-information');
  if (content.isConnected && anchor.parentNode) {
    moveContent(carousel, content, anchor.parentNode, anchor);
  }
  anchor.remove();
  placements.delete(carousel);
}

function placeCarousels() {
  for (const [carousel, placement] of placements) {
    if (!placement.section.isConnected) {
      // 原 Section 被编辑器删除时，清除挂在产品栏中的内容及其事件。
      placement.content.remove();
      restorePlacement(carousel, placement);
    } else if (!carousel.isConnected) {
      restorePlacement(carousel, placement);
    }
  }

  const targets = document.querySelectorAll(targetSelector);
  // 没有目标或存在多个主产品区域时不猜测，避免移动到错误商品。
  if (targets.length !== 1) return;
  const target = targets[0];

  document.querySelectorAll(carouselSelector).forEach((carousel) => {
    if (placements.has(carousel)) return;
    const section = carousel.closest('.shopify-section');
    const content = carousel.closest('[data-media-card-carousel-content]');
    if (!section || !content || section.contains(target) || target.contains(content)) return;

    const anchor = document.createComment('Media card carousel original position');
    // 保留 Shopify Section 外壳及边界，避免编辑器判定为损坏的嵌套 HTML。
    content.before(anchor);
    placements.set(carousel, { section, content, anchor });
    content.classList.add('section-media-card-carousel--product-information');
    moveContent(carousel, content, target);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', placeCarousels, { once: true });
} else {
  placeCarousels();
}

if (window.Shopify?.designMode) {
  // 主产品或来源 Section 重新渲染前归还内容，避免丢失或重复渲染。
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [carousel, placement] of placements) {
      if (event.target === placement.section || event.target.contains(placement.content)) {
        restorePlacement(carousel, placement);
      }
    }
  });
  document.addEventListener('shopify:section:load', placeCarousels);
  document.addEventListener('shopify:section:select', (event) => {
    for (const placement of placements.values()) {
      if (event.target === placement.section) {
        placement.content.scrollIntoView({ block: 'nearest' });
      }
    }
  });
  document.addEventListener('shopify:section:reorder', () => {
    // 恢复原始顺序后重新挂载，使多个轮播遵循编辑器排序。
    for (const [carousel, placement] of placements) restorePlacement(carousel, placement);
    placeCarousels();
  });
}
